export default __webpack_public_path__ + "static/media/malabsi.c501e9f5.png";